import {Type} from '@angular/core';
import {PaymentProvider} from '@gatewee/types/provider';
import {AvistaCredentialsComponent} from './avista-credentials/avista-credentials.component';
import {CdcCredentialsComponent} from './cdc-credentials/cdc-credentials.component';
import {E2CredentialsComponent} from './e2-credentials/e2-credentials.component';
import {FireCredentialsComponent} from './fire-credentials/fire-credentials.component';
import {LytexCredentialsComponent} from './lytex-credentials/lytex-credentials.component';
import {MarlimCredentialsComponent} from './marlim-credentials/marlim-credentials.component';
import {OnlyUpCredentialsComponent} from './onlyup-credentials/onlyup-credentials.component';
import {PagareCredentialsComponent} from './pagare-credentials/pagare-credentials.component';
import {PaytimeCredentialsComponent} from './paytime-credentials/paytime-credentials.component';
import {PlutechCredentialsComponent} from './plutech-credentials/plutech-credentials.component';
import {SandboxCredentialsComponent} from './sandbox-credentials/sandbox-credentials.component';
import {TransfeeraCredentialsComponent} from './transfeera-credentials/transfeera-credentials.component';
import {WepaymentsComponent} from './wepayments/wepayments.component';
import {WooviCredentialsComponent} from './woovi-credentials/woovi-credentials.component';

/** Maps a provider slug or enum value to its credentials form component. */
export function resolveCredentialComponent(
  provider: PaymentProvider | string,
): Type<unknown> | null {
  switch (provider) {
    case PaymentProvider.FIRE:
    case 'fire':
      return FireCredentialsComponent;
    case PaymentProvider.CDC:
    case 'cdc':
      return CdcCredentialsComponent;
    case PaymentProvider.E2:
    case 'e2':
      return E2CredentialsComponent;
    case PaymentProvider.WEPAYMENTS:
    case 'wepayments':
      return WepaymentsComponent;
    case PaymentProvider.PAYTIME:
    case 'paytime':
      return PaytimeCredentialsComponent;
    case PaymentProvider.TRANSFEERA:
    case 'transfeera':
      return TransfeeraCredentialsComponent;
    case PaymentProvider.LYTEX:
    case 'lytex':
      return LytexCredentialsComponent;
    case PaymentProvider.AVISTA:
    case 'avista':
      return AvistaCredentialsComponent;
    case PaymentProvider.WOOVI:
    case 'woovi':
      return WooviCredentialsComponent;
    case PaymentProvider.PLUTECH:
    case 'plutech':
      return PlutechCredentialsComponent;
    case PaymentProvider.MARLIM:
    case 'marlim':
      return MarlimCredentialsComponent;
    case PaymentProvider.PAGARE:
    case 'pagare':
      return PagareCredentialsComponent;
    case PaymentProvider.ONLYUP:
    case 'onlyup':
      return OnlyUpCredentialsComponent;
    case PaymentProvider.SANDBOX:
    case 'sandbox':
      return SandboxCredentialsComponent;
    default:
      return null;
  }
}

/** Maps a provider slug to the PaymentProvider enum value. */
export function resolveProviderFromSlug(content: string): PaymentProvider {
  switch (content) {
    case 'fire':
      return PaymentProvider.FIRE;
    case 'cdc':
      return PaymentProvider.CDC;
    case 'e2':
      return PaymentProvider.E2;
    case 'wepayments':
      return PaymentProvider.WEPAYMENTS;
    case 'paytime':
      return PaymentProvider.PAYTIME;
    case 'transfeera':
      return PaymentProvider.TRANSFEERA;
    case 'lytex':
      return PaymentProvider.LYTEX;
    case 'avista':
      return PaymentProvider.AVISTA;
    case 'woovi':
      return PaymentProvider.WOOVI;
    case 'plutech':
      return PaymentProvider.PLUTECH;
    case 'marlim':
      return PaymentProvider.MARLIM;
    case 'pagare':
      return PaymentProvider.PAGARE;
    case 'onlyup':
      return PaymentProvider.ONLYUP;
    case 'sandbox':
      return PaymentProvider.SANDBOX;
    default:
      throw new Error(`Unknown provider: ${content}`);
  }
}
